// PRODUCTION — flow editor config form layout row
import React from 'react'
import tw from 'twin.macro'

export const ConfigRow = ({
  label,
  children,
  required,
  top,
  disabled = false,
}: {
  label: string
  children: React.ReactNode
  required?: boolean
  top?: boolean
  disabled?: boolean
}) => (
  <div css={[tw`flex gap-4 px-5 py-3`, top ? tw`items-start` : tw`items-center`]}>
    <span
      css={[
        tw`flex w-40 flex-shrink-0 items-center gap-0.5 text-sm font-semibold`,
        disabled ? tw`text-shades-400` : tw`text-shades-800`,
      ]}
    >
      {label}
      {required && <span css={tw`text-[13px] text-critical-500`}>*</span>}
    </span>
    {children}
  </div>
)
